import React from "react";
import { useNavigate } from "react-router-dom";
import "./AuthPages.scss";

interface LogoutSuccessProps {
  clientType: "consumer" | "banker";
}

export const LogoutSuccess: React.FC<LogoutSuccessProps> = ({ clientType }) => {
  const navigate = useNavigate();

  const goToRoot = () => {
    navigate("/");
  };

  const loginAgain = () => {
    if (clientType === "consumer") {
      navigate("/");
    } else {
      navigate("/banker");
    }
  };

  return (
    <section className="logout-success">
      <div className="logout-success__content">
        <div className="logout-success__header">
          <h1 className="logout-success__title">Successfully Signed Out</h1>
          <div className="logout-success__icon">✓</div>
        </div>
        <p className="logout-success__description">
          You have been successfully signed out of your account.
        </p>

        <div className="logout-success__actions">
          <button
            className="logout-success__button logout-success__button--primary"
            onClick={loginAgain}
          >
            Sign In Again
          </button>
          <button
            className="logout-success__button logout-success__button--secondary"
            onClick={goToRoot}
          >
            Return to Home
          </button>
        </div>
      </div>
    </section>
  );
};
